import createStore from "astrid-helpers/src/createStore";

export const [getOutput, setOutput, useOutput] = createStore("default");
